function App() {
  return (
      // eslint-disable-next-line react/style-prop-object
      <div className="App">
          <h1>Hello World from React!</h1>
          <h3>hotfix/1.2.3l</h3>
      </div>
  );
}

export default App;

